import { render, staticRenderFns } from "./ClientProjects.vue?vue&type=template&id=41b8eb05&scoped=true&"
import script from "./ClientProjects.vue?vue&type=script&lang=js&"
export * from "./ClientProjects.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjects.vue?vue&type=style&index=0&id=41b8eb05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8eb05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b8eb05')) {
      api.createRecord('41b8eb05', component.options)
    } else {
      api.reload('41b8eb05', component.options)
    }
    module.hot.accept("./ClientProjects.vue?vue&type=template&id=41b8eb05&scoped=true&", function () {
      api.rerender('41b8eb05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Projects/ClientProjects.vue"
export default component.exports